<ng-container *transloco="let t">
  <div class="ultrasound-finding" [formGroup]="form">
    <div class="field">
      <label class="label">{{ t('ultrasound.region') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="region" rows="2"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('ultrasound.finding') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="finding" rows="4"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('ultrasound.diagnosis') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="diagnosis" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('ultrasound.therapy') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="therapy" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('ultrasound.note') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea
          matInput
          formControlName="note"
          rows="4"
          placeholder="{{ t('Additional notes') }}"
        ></textarea>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
